;(function() {
  'use strict'

  Controller.$inject = ["$state", "glAnalytics"];
  angular.module('app.linkNotFound').controller('LinkNotFound', Controller)

  /* @ngInject */
  function Controller($state, glAnalytics) {
    var link = $state.params.link
    var redirectState = 'app.public'

    if (link) {
      glAnalytics.track('Link Not Found', 'link', link)
    }

    // Redirect
    $state.go(redirectState)
    glAnalytics.track('Link Not Found', 'redirect', redirectState)
  }
})()
